var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBenefit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.803 76.4349C86.2228 68.2831 79.0478 62.1309 70.4305 62.1309C61.8133 62.1309 54.6383 68.2831 53.058 76.4349C52.7154 78.1942 54.1064 79.8256 55.8963 79.8256H84.9596C86.7547 79.8256 88.1406 78.1993 87.7979 76.4349H87.803Z",
    fill: "url(#paint0_linear_1846_70118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4305 57.9723C75.2829 57.9723 79.2165 54.0387 79.2165 49.1864C79.2165 44.334 75.2829 40.4004 70.4305 40.4004C65.5782 40.4004 61.6445 44.334 61.6445 49.1864C61.6445 54.0387 65.5782 57.9723 70.4305 57.9723Z",
    fill: "url(#paint1_linear_1846_70118)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1846_70118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7767 75.5757C61.7924 65.3578 52.7967 57.6406 41.9958 57.6406C31.1949 57.6406 22.1992 65.3578 20.215 75.5757C19.7854 77.785 21.5242 79.8255 23.7744 79.8255H60.2121C62.4623 79.8255 64.2011 77.785 63.7715 75.5757H63.7767Z",
    fill: "url(#paint2_linear_1846_70118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9958 58.1406C52.3897 58.1406 61.0742 65.4523 63.1911 75.2099L63.2807 75.6711C63.6482 77.5609 62.1591 79.3255 60.2121 79.3255H23.7744C21.8274 79.3255 20.3383 77.5609 20.7058 75.6711L20.7058 75.671C22.6453 65.6836 31.4389 58.1406 41.9958 58.1406Z",
    stroke: "url(#paint3_linear_1846_70118)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1846_70118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5178 52.1355C50.4362 50.7387 54.1016 44.8085 52.7048 38.8901C51.3079 32.9717 45.3777 29.3063 39.4593 30.7032C33.541 32.1 29.8755 38.0302 31.2724 43.9486C32.6693 49.867 38.5994 53.5324 44.5178 52.1355Z",
    fill: "url(#paint4_linear_1846_70118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2181 39.005C53.5516 44.6546 50.0526 50.3155 44.403 51.6489C38.7534 52.9823 33.0925 49.4834 31.759 43.8337C30.4256 38.1841 33.9246 32.5232 39.5742 31.1898C45.2238 29.8564 50.8847 33.3553 52.2181 39.005Z",
    stroke: "url(#paint5_linear_1846_70118)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1846_70118",
    x: 2.14941,
    y: 39.6406,
    width: 79.6875,
    height: 58.1855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1846_70118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1846_70118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1846_70118",
    x: 12.9756,
    y: 12.4062,
    width: 58.0259,
    height: 58.0254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1846_70118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1846_70118",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1846_70118",
    x1: 70.4305,
    y1: 89.5628,
    x2: 70.4305,
    y2: 36.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1846_70118",
    x1: 70.4697,
    y1: 67.8052,
    x2: 70.4305,
    y2: 36.3603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6005A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7CBAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1846_70118",
    x1: 22.6158,
    y1: 78.573,
    x2: 38.5056,
    y2: 47.2821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1846_70118",
    x1: 23.2333,
    y1: 59.3854,
    x2: 37.6382,
    y2: 89.7162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1846_70118",
    x1: 34.7261,
    y1: 53.1692,
    x2: 49.2511,
    y2: 29.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1846_70118",
    x1: 30.6539,
    y1: 34.561,
    x2: 53.0905,
    y2: 49.4883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefit);
export default __webpack_public_path__ + "static/media/icon-benefit.71e0474cbd834b6209f91054b85dba82.svg";
export { ForwardRef as ReactComponent };